import React from 'react';
import { localsMessages } from '../utility/getTemplateData';

const messages = localsMessages('common/payPalUrl');

class PayPalUrl extends React.Component {
  constructor() {
    super();
    const { label: { pp: ppLabel } = {} } = messages || {};
    this.state = {
      ppLabel,
    };
  }

  handleReturn = () => {
    window.location.href = 'https://www.paypal.com/home';
  };

  render() {
    const labelpp = this.state.ppLabel;
    return (
      <div className="ppvx_col-sm-12 text-center">
        <a
          className="btn btn-danger return_topp_btn"
          onClick={this.handleReturn}
        >
          {labelpp}
        </a>
      </div>
    );
  }
}

export default PayPalUrl;
